import { render } from "./Scoring_Risk.vue?vue&type=template&id=f4dba7ea&scoped=true"
import script from "./Scoring_Risk.vue?vue&type=script&lang=js"
export * from "./Scoring_Risk.vue?vue&type=script&lang=js"

import "./Scoring_Risk.vue?vue&type=style&index=0&id=f4dba7ea&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f4dba7ea"

export default script